import constant from "@/common/constant";
import store from "@/store";
import localAxios from "@/plugins/local.axios";

const localService = {
	defaultHeaders() {
		return {
			"Content-Type": "application/json",
		};
	},
	onReject(error) {
		console.error("onReject -> error", error);
	},
	async post(
		url,
		data,
		config = {},
		reject = (error) => {
			this.onReject(error);
		},
		showLoading = true,
	) {
		if (showLoading) {
			store.commit(constant.keys.loading, true);
		}
		let _url = await Promise.resolve(url);
		let response;
		try {
			response = await localAxios({
				url: _url,
				method: "POST",
				data: data,
				...config,
			});
			return response.data;
		} catch (reason) {
			if (reject instanceof Function) {
				return reject(reason);
			}
			return null;
		} finally {
			if (showLoading) {
				store.commit(constant.keys.loading, false);
			}
		}
	},
	async get(
		url,
		config = {},
		reject = (error) => {
			this.onReject(error);
		},
		showLoading = true,
	) {
		if (showLoading) {
			store.commit(constant.keys.loading, true);
		}
		let _url = await Promise.resolve(url);
		let response;
		try {
			response = await localAxios({
				url: _url,
				method: "GET",
				...config,
			});
			return response.data;
		} catch (rs) {
			if (reject instanceof Function) {
				return reject(rs);
			}
			return null;
		} finally {
			if (showLoading) {
				store.commit(constant.keys.loading, false);
			}
		}
	},
};

export default localService;
